module.exports = __webpack_public_path__ + "img/bars_light_solid.a7a91b71.svg";